// JavaScript code for acf_blocks/client-logos-carousel component
(($) => {

     "use strict";
     if (!$('.acf-blocks-client-logos-carousel').length) {
          return;
     }
     console.log("acf_blocks/client-logos-carousel scripts loaded...");

     $('.acf-blocks-client-logos-carousel').each(function () {
          const $imagesContainerCarousel = $(this);
          $imagesContainerCarousel.owlCarousel({
               loop: true,
               autoplay: true,
               autoplayTimeout: 3000,
               margin: 40,
               nav: false,
               dots: false,
               responsiveBaseElement: 'body',
               responsive: {
                    0: { items: 2 },
                    576: { items: 3 },
                    680: { items: 4 },
                    768: { items: 5 },
                    992: { items: 6 },
                    1200: { items: 7 },
                    1400: { items: 8 },
               }
          });
     });

})(jQuery);